import React from 'react';

import { cn } from '@/lib/utils';

import Card from '@/decodo/components/atoms/Card';
import LinkButton from '@/decodo/components/atoms/LinkButton';
import { LinkButtonStrapiProps } from '@/decodo/components/atoms/LinkButton/LinkStrapi';
import { Text } from '@/decodo/components/atoms/Text';

import IconSupport from '~/svg/IconSupport.svg';

export type SideBannerProps = {
  title: string;
  description: React.ReactNode;
  image: React.ReactNode;
  button?: LinkButtonStrapiProps;
  classNames?: {
    root?: string;
  };
};

export default function SideBanner({
  button,
  image,
  title,
  description,
  classNames,
}: SideBannerProps) {
  return (
    <Card
      classNames={{
        root: cn(
          'flex flex-col gap-3 dark:bg-transparent bg-transparent p-6',
          classNames?.root
        ),
      }}
      color='gradient'
    >
      <div className='flex items-center gap-4'>
        <div className={cn('flex flex-grow items-center gap-x-3 text-left')}>
          {!!image && image}
          <div className='space-y-3'>
            <Text variant='subtitle-l-d' color='base-black'>
              {title}
            </Text>
          </div>
        </div>
      </div>
      {!!description && <Text color='gray-500'>{description}</Text>}
      {button && (
        <LinkButton
          href={button.url}
          variant='outlined'
          color='secondary'
          fullwidth={true}
          leftSection={<IconSupport />}
        >
          {button.text}
        </LinkButton>
      )}
    </Card>
  );
}
